import { Timestamp } from 'firebase/firestore';
import { isValid, parseISO, format } from 'date-fns';
import { ERRORS } from './constants'; // Assuming constants.js is in utils

export const parseDate = (date, formatStr = null) => {
  if (!date) return formatStr ? 'N/A' : null;
  let dateObj;
  if (date instanceof Timestamp) {
    dateObj = date.toDate();
  } else if (
    typeof date === 'object' && date !== null && date.seconds !== undefined && date.nanoseconds !== undefined
  ) {
    dateObj = new Timestamp(date.seconds, date.nanoseconds).toDate();
  } else if (date instanceof Date) {
    dateObj = date;
  } else if (typeof date === 'string') {
    dateObj = parseISO(date);
    // Fallback for non-ISO strings - might be less reliable
    if (!isValid(dateObj)) {
        dateObj = new Date(date);
    }
  } else {
    return formatStr ? 'Invalid Date' : null;
  }

  if (!isValid(dateObj)) {
    return formatStr ? 'Invalid Date' : null;
  }

  return formatStr ? format(dateObj, formatStr) : dateObj;
};

export const formatDateTime = (date) => {
  if (!date) return 'N/A';
  let dateObj = parseDate(date); // Use the refined parseDate first
  return isValid(dateObj) ? format(dateObj, 'MMMM d, yyyy h:mm a') : 'Invalid Date';
};


export const getBase64ImageFromURL = async (url) => {
  try {
    // Ensure PUBLIC_URL is handled correctly (might need adjustment based on build setup)
    const publicUrl = process.env.PUBLIC_URL || ''; 
    const fullUrl = `${publicUrl}${url}?t=${new Date().getTime()}`;
    const res = await fetch(fullUrl, { headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' } });
    if (!res.ok) throw new Error(`Failed to fetch image from ${fullUrl}, status: ${res.status}`);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject; 
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error fetching image:', error);
    // Throw error so caller knows it failed, avoid showing toast here
    throw new Error(ERRORS.FETCH_IMAGE_FAILED); 
  }
}; 